export default __webpack_public_path__ + "static/media/mov.d5243050.svg";